import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';

export const routes: Routes = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },

  {
    path: 'auth',
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./features/auth/login/login.component').then(m => m.LoginComponent),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },

  {
    path: '',
    canActivate: [authGuard],
    component: AdminLayoutComponent,
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent,
      },
      {
        path: 'games',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/games/games.component').then(m => m.GamesComponent),
      },
      {
        path: 'challenges',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/challenges/challenges.component').then(m => m.ChallengesComponent),
      },
      {
        path: 'challenge-new',
        loadComponent: () =>
          import('./features/challenges/challenge-edit/challenge-edit.component').then(m => m.ChallengeEditComponent),
      },
      {
        path: 'challenge-edit',
        loadComponent: () =>
          import('./features/challenges/challenge-edit/challenge-edit.component').then(m => m.ChallengeEditComponent),
      },
      {
        path: 'challenge-edit/:id',
        loadComponent: () =>
          import('./features/challenges/challenge-edit/challenge-edit.component').then(m => m.ChallengeEditComponent),
      },
      {
        path: 'challenges/:id',
        loadComponent: () =>
          import('./features/challenges/challenge-detail/challenge-detail.component').then(m => m.ChallengeDetailComponent),
      },
      {
        path: 'games/:slug',
        loadComponent: () =>
          import('./features/games/game-detail/game-detail.component').then(m => m.GameDetailComponent),
      },
      {
        path: 'game-edit-or-add',
        loadComponent: () =>
          import('./features/games/game-edit-or-add/game-edit.component').then(m => m.GameEditComponent),
      },
      {
        path: 'game-edit-or-add/:slug',
        loadComponent: () =>
          import('./features/games/game-edit-or-add/game-edit.component').then(m => m.GameEditComponent),
      },
      {
        path: 'rewards',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/rewards/rewards.component').then(m => m.RewardsComponent),
      },
      {
        path: 'settings/badges',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/badges/badges.component').then(m => m.BadgesComponent),
      },
      {
        path: 'settings/collections',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/collections/collections.component').then(m => m.CollectionsComponent),
      },
      {
        path: 'settings/achievements',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/achievements/achievements.component').then(m => m.AchievementsComponent),
      },
      {
        path: 'categories',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/categories/categories.component').then(m => m.CategoriesComponent),
      },
      {
        path: 'categories/:id',
        loadComponent: () =>
          import('./features/categories/category-detail/category-detail.component').then(m => m.CategoryDetailComponent),
      },
      {
        path: 'category-edit',
        loadComponent: () =>
          import('./features/categories/category-edit/category-edit.component').then(m => m.CategoryEditComponent),
      },
      {
        path: 'leaderboards',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/leaderboards/leaderboards.component').then(m => m.LeaderboardsComponent),
      },
      {
        path: 'players',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/users/players/players.component').then(m => m.PlayersComponent),
      },
      {
        path: 'players/:id',
        loadComponent: () =>
          import('./features/users/player-detail/player-detail.component').then(m => m.PlayerDetailComponent),
      },
      {
        path: 'players/:id/history',
        loadComponent: () =>
          import('./features/users/player-history/player-history.component').then(m => m.PlayerHistoryComponent),
      },
      {
        path: 'admins',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/users/admins/admins.component').then(m => m.AdminsComponent),
      },
      {
        path: 'admin-add',
        loadComponent: () =>
          import('./features/users/admins/admin-add.component').then(m => m.AdminAddComponent),
      },
      {
        path: 'promotion/home-banners',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/home-banners/home-banners.component').then(m => m.HomeBannersComponent),
      },
      {
        path: 'promotion/ad-banners',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/banners/banners.component').then(m => m.BannersComponent),
      },
      {
        path: 'promotion/push-notifications',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/push-notifications/push-notifications.component').then(m => m.PushNotificationsComponent),
      },
      {
        path: 'content/cms-pages',
        loadComponent: () =>
          import('./features/cms-pages/cms-pages.component').then(m => m.CmsPagesComponent),
      },
      {
        path: 'settings/cms-pages',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/cms-pages/cms-pages.component').then(m => m.CmsPagesComponent),
      },
      {
        path: 'claims',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/prize-claims/prize-claims.component').then(m => m.PrizeClaimsComponent),
      },
      {
        path: 'claims/:id',
        loadComponent: () =>
          import('./features/prize-claims/claim-detail/claim-detail.component').then(m => m.ClaimDetailComponent),
      },
      {
        path: 'settings/faqs',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/faq/faq.component').then(m => m.FaqComponent),
      },
      {
        path: 'settings/language',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/language-settings/language-settings.component').then(m => m.LanguageSettingsComponent),
      },
      {
        path: 'settings/email',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/email-settings/email-settings.component').then(m => m.EmailSettingsComponent),
      },
      {
        path: 'settings/global',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/global-settings/global-settings.component').then(m => m.GlobalSettingsComponent),
      },
      {
        path: 'support',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/support/support.component').then(m => m.SupportComponent),
      },
      {
        path: 'moderation',
        canActivate: [permissionGuard],
        loadComponent: () =>
          import('./features/moderation/moderation.component').then(m => m.ModerationComponent),
      },
    ],
  },
];
